import React from 'react';
import Btnlist from '../../containers/btnList.jsx';
import styles from './btnList-phone.css';

class BtnListPhone extends React.Component{
    constructor(){
        super()
    }
    render(){
        const {
            vm
        } = this.props
        const defaultType = vm.editingTarget ? vm.editingTarget.robotType : 'E6'
        return(
            <div className={styles.btnBox}>
                <Btnlist
                    vm={vm}
                    defaultType={defaultType}
                />
            </div>
        )
    }
}

export default BtnListPhone